import { render } from "./examination-info.vue?vue&type=template&id=05146344&scoped=true&ts=true"
import script from "./examination-info.vue?vue&type=script&lang=ts"
export * from "./examination-info.vue?vue&type=script&lang=ts"

import "./examination-info.vue?vue&type=style&index=0&id=05146344&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05146344"]])

export default __exports__